import { useState } from 'react';
import AppBreadcrumb from '../../../components/Breadcrumb';
import DetailViewPage from '../../../components/DetailViewPage';

export default function JobDetailPage() {
  const [headerData, setHeaderData] = useState(null);

  const breadcrumbItems = [
    { label: 'Home', href: '/dashboard' },
    { label: 'Jobs', href: '/jobs' },
    { label: headerData?.eyebrow || '-' },
  ];

  return (
    <div>
      <AppBreadcrumb items={breadcrumbItems} />
      <DetailViewPage
        moduleName="job"
        backPath="/jobs"
        onHeaderData={setHeaderData}
      />
    </div>
  );
}
